export const workplaceConstants = {
  CAN_ACCESS_CREATE_PAGE_REQUEST: 'WORKPLACE/CAN_ACCESS_CREATE_PAGE_REQUEST',
  CAN_ACCESS_CREATE_PAGE_SUCCESS: 'WORKPLACE/CAN_ACCESS_CREATE_PAGE_SUCCESS',
  CAN_ACCESS_CREATE_PAGE_FAILURE: 'WORKPLACE/CAN_ACCESS_CREATE_PAGE_FAILURE',

  CREATE_WORKPLACE_REQUEST: 'WORKPLACE/CREATE_WORKPLACE_REQUEST',
  CREATE_WORKPLACE_SUCCESS: 'WORKPLACE/CREATE_WORKPLACE_SUCCESS',
  CREATE_WORKPLACE_FAILURE: 'WORKPLACE/CREATE_WORKPLACE_FAILURE',

  APPROVE_INVITATION_REQUEST: 'WORKPLACE/APPROVE_INVITATION_REQUEST',
  APPROVE_INVITATION_SUCCESS: 'WORKPLACE/APPROVE_INVITATION_SUCCESS',
  APPROVE_INVITATION_FAILURE: 'WORKPLACE/APPROVE_INVITATION_FAILURE',

  REJECT_INVITATION_REQUEST: 'WORKPLACE/REJECT_INVITATION_REQUEST',
  REJECT_INVITATION_SUCCESS: 'WORKPLACE/REJECT_INVITATION_SUCCESS',
  REJECT_INVITATION_FAILURE: 'WORKPLACE/REJECT_INVITATION_FAILURE'
}
